import type { CellProps } from 'react-table';
import { Brand as BrandIcon } from '@/components/icons/Brand';
import { QuantAnalysis } from '@/components/icons/QuantAnalysis';
import ClickContainer from './ResultClickContainer';
import type { QuantAnalysesTableItem } from './interfaces';
import styles from './style/Cell.Name.module.css';

export default function Name({ row: { original: data } }: CellProps<QuantAnalysesTableItem>) {
  return (
    <ClickContainer className={styles.overflowWrapper} item={data}>
      <div className={styles.root}>
        <QuantAnalysis
          className={styles.icon} />
        <div className={styles.details}>
          <div className={styles.name}>{data.name}</div>
        </div>
      </div>
    </ClickContainer>
  );
}

export { Name };